import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import SnapchatAccountService from '../../services/SnapchatAccountService';
import ChromeExtensionService from '../../services/ChromeExtensionService';
import './SnapchatLogin.css';

const ERROR_TEXT = 'Oops! Something went wrong. Please retry.';
class SnapchatLogin extends Component {
    constructor (props) {
        super(props);
        this.login = this.login.bind(this);
    }
    login() {
        // make login request
        ChromeExtensionService.sendMessage({signal: 'BitmojiWebAppLoginRequested'},
            (response) => {
                if ((typeof response !== 'undefined') && response.signal === 'ChromeExtLoginReceived') {

                    const redirectAccountsURL =
                        SnapchatAccountService.getRedirectURL(
                            response.client_id, response.scope, response.state, response.code_challenge);

                    window.location.href = redirectAccountsURL;
                }
            });
    }
    render() {
        const { isUserLoggingIn, isLoginError } = this.props;

        return (
            <div id="snapchat-login-container">
                { isLoginError ?
                    <div className="snapchat-login-error">
                        <p>{ERROR_TEXT}</p>
                    </div> : null
                }
                { isUserLoggingIn ?
                    <button className="sc-button-logging-in" name="snapchat-login-in-progress" />
                    :
                    <button className="sc-button" name="snapchat-login-button" onClick={this.login}>
                        <span className="label-normal">Log In with Snapchat</span>
                    </button>
                }

            </div>
        );
    }
}

SnapchatLogin.propTypes = {
    isUserLoggingIn: PropTypes.bool.isRequired,
    isLoginError: PropTypes.bool.isRequired
};

export default SnapchatLogin;



// WEBPACK FOOTER //
// ./src/components/login_view/SnapchatLogin.js